module.exports = __webpack_public_path__ + "static/media/18.536afe72.jpg";